






import { FormDetail } from "@/components/TruckingSalesOrder";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    FormDetail,
  },
})
export default class DetailPage extends Vue {}
